import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPlayerProfilePictureName } from "../../../balancingSelectors/selectBalancingPictures";
import { selectPlayerLevelFromXp } from "../../../balancingSelectors/selectBalancingXpLevels";
import { IdLeagues } from "../../../constants/IdLeagues";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionSetCurrentPlayerProfile, TypeActionPlayerProfile, } from "../actionPlayerProfile";
export var epicOpenOtherPlayerProfile = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerProfile.OpenOtherPlayerProfile), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.PlayerProfileInfo,
            props: {
                playerId: action.id,
            },
        });
    }), retry(), switchMap(function (res) {
        var playerId = res.playerId, name = res.name, xp = res.xp, profilePictureId = res.profilePictureId, coopId = res.coopId, coopLeagueId = res.coopLeagueId, coopLevel = res.coopLevel, coopName = res.coopName, playerLeagueId = res.playerLeagueId;
        var level = selectPlayerLevelFromXp(xp);
        var picture = selectPlayerProfilePictureName(profilePictureId);
        var coop = coopId === undefined || Long.ZERO.equals(coopId)
            ? undefined
            : {
                coopLeagueId: coopLeagueId || IdLeagues.Bronze1,
                id: coopId || Long.ZERO,
                level: coopLevel || 1,
                name: coopName || "",
            };
        return from([
            actionSetCurrentPlayerProfile(playerId, level, name, picture, playerLeagueId || IdLeagues.Bronze1, coop),
            actionModalOpen(IdModal.PlayerProfile),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/epics/epicOpenOtherPlayerProfile.ts
// module id = 2102
// module chunks = 3